module.exports = __webpack_public_path__ + "static/media/smile2.1acc5b42.gif";